<template>
  <div class="site-setup-logo-content">
    <Notification
      v-if="notification.active"
      :content="notification.content"
      :type="notification.type"/>

    <FileUploadForm
      label="Site Logo"
      helpText="File types accepted: <strong>JPG, PNG</strong>"
      paramResource="site"
      paramName="logo"
      :showUnsplash="false"
      :images="images"
      :errors="errors"
      :stringUpdateFunction="stringUpdateFunction"
      :fileUpdateFunction="fileUpdateFunction"
    />

    <Btn v-if="images.length" secondary class="btn-remove" @click="deleteLogo">
      Delete Logo
    </Btn>
  </div>
</template>

<script>
import notification from '@/mixins/notification'
import {mapGetters} from 'vuex'

import {
  readCompanySiteData,
  updateCompanySiteData,
  updateCompanySiteLogoImage,
  deleteCompanySiteLogoImage
} from '@/lib/sites'

import FileUploadForm from '@/components/forms/FileUploadForm'
import Btn from '@/components/Btn'

export default {
  name: 'logoContent',

  components: {
    FileUploadForm,
    Btn
  },

  mixins: [notification],

  props: {
    siteId: String,
    companyId: String
  },

  data() {
    return {
      site: {},
      errors: {}
    }
  },

  computed: {
    ...mapGetters(['sessionToken']),

    images() {
      return this.site.logo_versions || []
    },

    stringUpdateFunction() {
      const companyId = this.companyId
      const siteId = this.siteId

      return (logo) => {
        return updateCompanySiteData(companyId, siteId, logo)
          .then(({data}) => {
            // computed is currying callback function to be used by upload form
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.site = data
            this.$emit('updatePage')
            this.triggerNotification('success', 'logo', 'updated')

            return data
          })
          .catch(({response}) => {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.errors = response.errors
          })
      }
    },

    fileUpdateFunction() {
      const companyId = this.companyId
      const siteId = this.siteId
      const token = this.sessionToken

      return (logo) => {
        return updateCompanySiteLogoImage(companyId, siteId, logo, token)
          .then(({data}) => {
            // computed is currying callback function to be used by upload form
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.site = data
            this.$emit('updatePage')
            this.triggerNotification('success', 'logo', 'updated')

            return data
          })
          .catch(({response}) => {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.errors = response.errors
          })
      }
    }
  },

  methods: {
    deleteLogo() {
      deleteCompanySiteLogoImage(this.companyId, this.siteId).then(() => {
        this.site.logo_versions = []
        this.$emit('updatePage')
        this.triggerNotification('success', 'logo', 'deleted')
      })
    },

    getData() {
      readCompanySiteData(this.companyId, this.siteId).then(({data}) => {
        this.site = data
      })
    }
  },

  mounted() {
    let text = 'Do you have a logo for your business? No problem if not - you can continue for now.'

    this.$emit('setContinue', {
      name: 'servicesContent'
    }, text)

    this.getData()
  }
}
</script>

<style lang="sass" scoped>
@import '../../stylesheets/base/variables'
@import '../../stylesheets/base/animations'
@import '../../stylesheets/helpers/mixins'
@import '../../stylesheets/helpers/extends'

.site-setup-logo-content
  max-width: 500px
  margin: auto
</style>
